import { ReactComponent as NotFoundSvg } from '../images/not-found.svg';
import {ReactComponent as WebhelpLogoDark} from '../images/webhelp-logo-dark.svg'

export const NotFoundIcon = NotFoundSvg;
export const WebhelpLogo = WebhelpLogoDark;